document.addEventListener('DOMContentLoaded', function() {
    // Function to check and remove paragraphs ending with ": "
    function removeEmptyFields() {
      // Get all divs with the class .autoremmer
      const autoremmerDivs = document.querySelectorAll('div.autoremmer');
  
      autoremmerDivs.forEach(function(div) {
        // Find all <p> tags within the .autoremmer div
        const paragraphs = div.querySelectorAll('p');
  
        paragraphs.forEach(function(paragraph) {
          // Trim the content and check if it ends with ": "
          if (paragraph.textContent.trim().endsWith(':')) {
            paragraph.style.display = 'none'; // Hide the paragraph
          }
          if (paragraph.textContent.trim().endsWith(': cm')) {
            paragraph.style.display = 'none'; // Hide the paragraph
          }
          if (paragraph.textContent.trim().endsWith(': kg')) {
            paragraph.style.display = 'none'; // Hide the paragraph
          }
          if (paragraph.textContent.trim().endsWith(': mm')) {
            paragraph.style.display = 'none'; // Hide the paragraph
          }
          if (paragraph.textContent.trim().endsWith(': ft')) {
            paragraph.style.display = 'none'; // Hide the paragraph
          }
          if (paragraph.textContent.trim().endsWith(': g')) {
            paragraph.style.display = 'none'; // Hide the paragraph
          }
        });
      });
    }
  
    // Initial check when the page loads
    removeEmptyFields();
  
    // Optional: Re-run the check if content changes dynamically
    // (You can trigger this when new content is added or changed)
    // Example: If content changes dynamically, you could trigger the function again
    // removeEmptyFields(); 
  });
  




  document.querySelectorAll('.header-search dialog-close-button').forEach(function(button) {
    button.addEventListener('click', function(e) {
        e.preventDefault();
        // Select the input element with the class .header-search__input
const searchInput = document.querySelector('.header-search__input');

// Focus the input (simulates a user clicking into the input field)
searchInput.focus();

// Trigger the 'input' event (simulates typing inside the input field)
searchInput.value = ''; // Set a value to the input
searchInput.dispatchEvent(new Event('input'));

// Trigger the 'change' event (simulates a change in the input field)
searchInput.dispatchEvent(new Event('change'));

// Trigger the 'keydown', 'keyup', and 'keypress' events (simulates keypresses)
const keyPressEvent = new KeyboardEvent('keydown', { key: 'Enter' });
searchInput.dispatchEvent(keyPressEvent);
searchInput.dispatchEvent(new KeyboardEvent('keyup', { key: 'Enter' }));
searchInput.dispatchEvent(new KeyboardEvent('keypress', { key: 'Enter' }));

// Blur the input (simulates a user clicking away from the input field)
searchInput.blur();

// Optionally, if the input is part of a form, submit the form programmatically

    });
});


function setEqualHeights() {
  document.querySelectorAll('.multi-column').forEach(function(section) {
      // Get all images within the current section
      const images = section.querySelectorAll('.multi-column__item .overflow-hidden');
      
      let maxHeight = 0;
      
      // Loop through images to find the tallest height
      images.forEach(function(img) {
          // Reset height to auto to get the natural height first
          img.style.height = 'auto';
          
          // Get the natural height of the image
          const imgHeight = img.offsetHeight;
          
          // Update maxHeight if the current image is taller
          if (imgHeight > maxHeight) {
              maxHeight = imgHeight;
          }
      });
      
      // Set all images to the tallest height found
      images.forEach(function(img) {
          img.style.height = maxHeight + 'px';
      });






      // Get all images within the current section
      const texts = section.querySelectorAll('.multi-column__item .h3');
      
      let tmaxHeight = 0;
      
      // Loop through images to find the tallest height
      texts.forEach(function(img) {
          // Reset height to auto to get the natural height first
          img.style.height = 'auto';
          
          // Get the natural height of the image
          const imgHeight = img.offsetHeight;
          
          // Update maxHeight if the current image is taller
          if (imgHeight > tmaxHeight) {
            tmaxHeight = imgHeight;
          }
      });
      
      // Set all images to the tallest height found
      texts.forEach(function(img) {
          img.style.height = tmaxHeight + 'px';
      });
  });
}

// Run on page load
setEqualHeights();

// Run on window resize
window.addEventListener('resize', function() {
  setEqualHeights();
});








// Select the input and header elements
const searchInput = document.querySelector('.header-search__input');
const headerSearch = document.querySelector('.header-search');

// Function to update data attribute with character count
function updateCharacterCount() {
    const characterCount = searchInput.value.length;
    headerSearch.setAttribute('data-character-count', characterCount);
}

// Add event listeners for change, keyup, paste, and enter
searchInput.addEventListener('change', updateCharacterCount);
searchInput.addEventListener('keyup', updateCharacterCount);
searchInput.addEventListener('paste', () => {
    setTimeout(updateCharacterCount, 0); // Delay to ensure paste content is updated
});

// Optional: Add an event listener for the Enter key
searchInput.addEventListener('keypress', (e) => {
    if (e.key === 'Enter') {
        updateCharacterCount();
    }
});




// JavaScript
document.addEventListener('DOMContentLoaded', () => {
  const countdownElements = document.querySelectorAll('[data-countdown]');

  function updateCountdowns() {
      countdownElements.forEach(el => {
          const countdownSpan = el.querySelector('.countdown');
          const targetDate = new Date(el.getAttribute('data-countdown'));
          const now = new Date();
          const diff = targetDate - now;

          if (diff <= 0) {
              // Time exceeded: hide the countdown text
              countdownSpan.textContent = '';
          } else {
              // Calculate time left
              const days = Math.floor(diff / (1000 * 60 * 60 * 24));
              const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
              const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));

              // Determine the display format
              if (days > 0) {
                  countdownSpan.textContent = `${days} day${days > 1 ? 's' : ''}`;
              } else if (hours > 0) {
                  countdownSpan.textContent = `${hours} hour${hours > 1 ? 's' : ''} ${minutes} minute${minutes > 1 ? 's' : ''}`;
              } else {
                  countdownSpan.textContent = `${minutes} minute${minutes > 1 ? 's' : ''}`;
              }
          }
      });
  }

  // Initial update
  updateCountdowns();

  // Update countdown every minute
  setInterval(updateCountdowns, 60000);
});


document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll(".header__menu-disclosure").forEach(function (menuItem) {
        let observer = new MutationObserver(mutations => {
            mutations.forEach(mutation => {
                if (mutation.attributeName === "aria-expanded") {
                    let megaMenu = menuItem.querySelector(".mega-menu");
                    if (megaMenu) {
                        let isOpen = menuItem.getAttribute("aria-expanded") === "true";
                        let bgColor = megaMenu.getAttribute("data-bg-color");
                        let linksColor = megaMenu.getAttribute("data-links-color");

                        if (isOpen) {
                            if (bgColor) {
                                megaMenu.style.backgroundColor = bgColor;
                            }
                            if (linksColor) {
                                megaMenu.querySelectorAll("a").forEach(link => {
                                    link.style.color = linksColor;
                                });
                            }
                        } else {
                            megaMenu.style.backgroundColor = ""; // Reset background color
                            megaMenu.querySelectorAll("a").forEach(link => {
                                link.style.color = ""; // Reset link color
                            });
                        }
                    }
                }
            });
        });

        observer.observe(menuItem, { attributes: true });
    });
});















jQuery('.vidcontrolplaceholder').on('click', function(e) {
    e.preventDefault();
    jQuery(this).parent().addClass('playvidder');
    jQuery(this).parent().find('video')[0].play();
});










jQuery('.morccrnt-arrow-right').on('click', function(e) {
    if(jQuery(this).parent().next().find('.tap-area[aria-current="true"]').next()) {
        jQuery(this).parent().next().find('.tap-area[aria-current="true"]').next().click();
    } else {
        jQuery(this).parent().next().find('.tap-area:first-child').click();
    }
});


jQuery('.morccrnt-arrow-left').on('click', function(e) {
    if(jQuery(this).parent().next().find('.tap-area[aria-current="true"]').prev()) {
        jQuery(this).parent().next().find('.tap-area[aria-current="true"]').prev().click();
    } else {
        jQuery(this).parent().next().find('.tap-area:last-child').click();
    }
});


